var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractOfAdhesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 377,
    viewBox: "0 0 452 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_35949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.737 245.456C417.647 283.198 388.854 324.052 348.326 336.151C287.103 354.434 279.79 403.787 170.132 399.202C153.037 398.494 137.233 396.082 122.712 392.253C114.911 390.195 107.474 387.706 100.419 384.834C36.3628 358.885 2.94676 301.778 0.17086 242.029C-3.49524 163.442 51.3431 125.977 86.9799 104.048C122.617 82.1084 165.566 -2.88188 273.405 0.774643C289.85 1.33939 306.247 3.58883 322.146 7.89626C358.434 17.7172 395.315 39.4362 416.747 71.1867C418.355 73.5702 419.887 76.011 421.361 78.4998C450.048 127.164 450.948 193.996 431.737 245.456Z",
    fill: "#DFFF02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M431.737 245.456C417.647 283.198 388.854 324.052 348.326 336.151C287.103 354.434 279.79 403.787 170.132 399.202C153.037 398.494 137.233 396.082 122.712 392.253C114.911 390.195 107.474 387.706 100.419 384.834C36.3628 358.885 2.94676 301.778 0.17086 242.029C-3.49524 163.442 51.3431 125.977 86.9799 104.048C122.617 82.1084 165.566 -2.88188 273.405 0.774643C289.85 1.33939 306.247 3.58883 322.146 7.89626C358.434 17.7172 395.315 39.4362 416.747 71.1867C418.355 73.5702 419.887 76.011 421.361 78.4998C450.048 127.164 450.948 193.996 431.737 245.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.639 0.478516H73.8867V298.036H179.639V0.478516Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 9.52415H179.43L176.96 1.34961",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 19.4322H179.43L176.96 11.248",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 29.3384H179.43L176.96 21.1543",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 39.2447H179.43L176.96 31.0605",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 49.1529H179.43L176.96 40.9688",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 59.0591H179.43L176.96 50.875",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 68.9673H179.43L176.96 60.7832",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 78.8736H179.43L176.96 70.6895",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 88.7798H179.43L176.96 80.5957",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 98.688H179.43L176.96 90.5039",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 108.594H179.43L176.96 100.41",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 118.502H179.43L176.96 110.318",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 128.409H179.43L176.96 120.225",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 138.307H179.43L176.96 130.133",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 148.214H179.43L176.96 140.039",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 158.12H179.43L176.96 149.945",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 168.028H179.43L176.96 159.854",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 177.934H179.43L176.96 169.76",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 187.843H179.43L176.96 179.668",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 197.749H179.43L176.96 189.574",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 207.657H179.43L176.96 199.482",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 217.563H179.43L176.96 209.379",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 227.471H179.43L176.96 219.287",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 237.377H179.43L176.96 229.193",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 247.284H179.43L176.96 239.1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 257.192H179.43L176.96 249.008",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 267.098H179.43L176.96 258.914",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 277.006H179.43L176.96 268.822",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4531 286.913H179.43L176.96 278.729",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.354 0.478516H187.602V298.036H293.354V0.478516Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 9.52415H293.145L290.685 1.34961",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 19.4322H293.145L290.685 11.248",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 29.3384H293.145L290.685 21.1543",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 39.2447H293.145L290.685 31.0605",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 49.1529H293.145L290.685 40.9688",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 59.0591H293.145L290.685 50.875",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 68.9673H293.145L290.685 60.7832",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 78.8736H293.145L290.685 70.6895",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 88.7798H293.145L290.685 80.5957",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 98.688H293.145L290.685 90.5039",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 108.594H293.145L290.685 100.41",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 118.502H293.145L290.685 110.318",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 128.409H293.145L290.685 120.225",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 138.307H293.145L290.685 130.133",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 148.214H293.145L290.685 140.039",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 158.12H293.145L290.685 149.945",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 168.028H293.145L290.685 159.854",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 177.934H293.145L290.685 169.76",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 187.843H293.145L290.685 179.668",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 197.749H293.145L290.685 189.574",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 207.657H293.145L290.685 199.482",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 217.563H293.145L290.685 209.379",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 227.471H293.145L290.685 219.287",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 237.377H293.145L290.685 229.193",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 247.284H293.145L290.685 239.1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 257.192H293.145L290.685 249.008",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 267.098H293.145L290.685 258.914",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 277.006H293.145L290.685 268.822",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168 286.913H293.145L290.685 278.729",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6672 19.3066H9.4375V36.5363H26.6672V19.3066Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6672 48.6543H9.4375V65.884H26.6672V48.6543Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.043 28.2383H59.213",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.043 56.9531H59.213",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 24.409L15.8118 29.511L27.2983 12.2812",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.284 362.943H264.055V380.173H281.284V362.943Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.284 392.291H264.055V409.521H281.284V392.291Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66 371.875H313.83",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66 400.59H313.83",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.883 368.046L270.429 373.148L281.915 355.918",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.03 10.0508H321.801V27.2805H339.03V10.0508Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.03 39.4082H321.801V56.6379H339.03V39.4082Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.414 18.9824H371.575",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.414 47.6992H371.575",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.629 15.1534L328.185 20.2649L339.671 3.03516",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.164 389.928H451.407",
    stroke: "#BBBBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7109 389.928H430.532",
    stroke: "#BBBBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0616 325.69C105.22 325.69 110.213 312.598 110.213 296.448C110.213 280.297 105.22 267.205 99.0616 267.205C92.9028 267.205 87.9102 280.297 87.9102 296.448C87.9102 312.598 92.9028 325.69 99.0616 325.69Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.701 278.413C130.217 289.383 123.517 297.04 118.75 295.528C113.973 294.015 112.93 283.888 116.414 272.919C119.898 261.949 126.599 254.291 131.366 255.804C136.142 257.316 137.186 267.443 133.701 278.413Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8992 344.556C40.5563 342.632 32.0276 337.071 32.8699 332.132C33.7027 327.193 43.581 324.752 54.9335 326.666C66.2764 328.59 74.8051 334.151 73.9627 339.091C73.13 344.03 63.2516 346.471 51.8992 344.556Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.203 317.514C134.726 326.914 123.527 330.992 119.191 326.617C114.855 322.243 119.028 311.082 128.505 301.682C137.981 292.282 149.18 288.204 153.516 292.579C157.853 296.953 153.679 308.114 144.203 317.514Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.891 291.738C88.0514 305.034 90.7891 319.057 84.9884 323.048C79.1877 327.04 67.0599 319.506 57.8995 306.201C48.739 292.906 46.0014 278.883 51.8021 274.891C57.6027 270.9 69.7305 278.433 78.891 291.738Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8438 324.225L100.705 364.427",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8125 285.572L99.8463 324.224",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8795 279.266L98.8125 282.223",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9531 321.143C90.5432 332.878 95.0899 347.131 95.961 363.327",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7969 291.852C70.9945 297.853 78.633 307.894 84.9506 321.152",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7656 285.477C59.7656 285.477 60.9238 286.53 62.8191 288.549",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.881 325.277C113.381 334.266 106.843 346.03 101.809 361.144",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.705 310.537C128.771 314.27 124.33 319.123 119.879 325.278",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.404 300.104C146.404 300.104 142.432 302.142 136.641 307.024",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.413 292.809C113.239 312.24 104.949 340.966 101.082 365.891",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.172 281.275C122.071 284.549 120.798 288.445 119.41 292.8",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.029 270.123C127.029 270.123 125.947 273.1 124.215 278.202",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3867 336.4C81.1018 339.329 88.635 344.967 92.3011 355.659",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1367 333.5C63.291 333.739 68.3833 334.495 73.3895 336.4",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8984 333.731C49.8984 333.731 51.2768 333.539 53.5358 333.443",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.008 344.556C160.351 342.632 168.879 337.071 168.037 332.132C167.204 327.193 157.326 324.752 145.973 326.666C134.63 328.59 126.102 334.151 126.944 339.091C127.777 344.03 137.655 346.471 149.008 344.556Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.767 336.305C119.966 339.205 112.308 344.853 108.613 355.659",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.966 333.443C138.678 333.606 133.183 334.295 127.766 336.305",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.007 333.73C151.007 333.73 150.098 333.605 148.547 333.5",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.604 389.822C130.935 382.854 132.878 374.813 132.878 366.811C132.878 361.853 132.131 357.105 130.772 352.74H71.3871C70.0279 357.115 69.2812 361.853 69.2812 366.811C69.2812 374.823 71.2244 382.863 74.5555 389.822H127.613H127.604Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8573 359.316C69.685 360.398 69.5606 361.499 69.4648 362.609H132.688C132.593 361.499 132.459 360.398 132.286 359.316H69.8573Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.018 376.125C132.219 375.034 132.391 373.942 132.516 372.832H69.6367C69.7707 373.933 69.943 375.034 70.1345 376.125H132.008H132.018Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9474 366.993C76.9474 368.41 75.7988 369.549 74.3917 369.549C72.9846 369.549 71.8359 368.4 71.8359 366.993C71.8359 365.586 72.9846 364.438 74.3917 364.438C75.7988 364.438 76.9474 365.586 76.9474 366.993Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7482 366.993C89.7482 368.41 88.5995 369.549 87.1925 369.549C85.7854 369.549 84.6367 368.4 84.6367 366.993C84.6367 365.586 85.7854 364.438 87.1925 364.438C88.5995 364.438 89.7482 365.586 89.7482 366.993Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.533 366.993C102.533 368.41 101.385 369.549 99.9776 369.549C98.5705 369.549 97.4219 368.4 97.4219 366.993C97.4219 365.586 98.5705 364.438 99.9776 364.438C101.385 364.438 102.533 365.586 102.533 366.993Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.334 366.993C115.334 368.41 114.185 369.549 112.778 369.549C111.371 369.549 110.223 368.4 110.223 366.993C110.223 365.586 111.371 364.438 112.778 364.438C114.185 364.438 115.334 365.586 115.334 366.993Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.119 366.993C128.119 368.41 126.971 369.549 125.564 369.549C124.156 369.549 123.008 368.4 123.008 366.993C123.008 365.586 124.156 364.438 125.564 364.438C126.971 364.438 128.119 365.586 128.119 366.993Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.176 41.123H210.922V358.226H435.176V41.123Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.633 35.5801H205.379V352.683H429.633V35.5801Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.615 67.0527H214.816V124.495H418.615V67.0527Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.696 55.25H214.816V67.0524H281.696V55.25Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.614 55.25H351.734V67.0524H418.614V55.25Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 85.9395H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 104.039H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.615 142.184H214.816V199.626H418.615V142.184Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 161.07H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 179.17H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 71.666H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.539 71.666H369.312",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 58.2285H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.777 58.2285H377.559",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 89.5762H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 109.275H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.688 109.275H319.46",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.684 56.1406H340.238",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.684 61.2148H340.238",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.699 119.986H296.927",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.742 119.986H310.97",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.781 119.986H325.019",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.615 211.697H214.816V269.139H418.615V211.697Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.286 226.476C219.286 226.476 223.077 216.999 220.798 219.277C218.52 221.556 216.625 229.51 222.311 227.615C227.997 225.719 231.787 217.382 230.275 220.79C228.762 224.197 229.519 226.858 234.065 224.197C238.612 221.546 239.368 221.546 239.751 223.058C240.134 224.571 241.263 224.197 245.437 222.675C249.61 221.163 249.227 223.815 249.227 224.954C249.227 226.093 254.53 225.71 256.426 224.954C258.321 224.197 259.833 221.919 260.216 224.571C260.599 227.222 264.39 227.222 264.39 227.222H274.622",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 230.582H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 248.684H418.615",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 216.311H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.539 216.311H369.312",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 234.219H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.148 253.918H242.93",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.688 253.918H319.46",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.699 264.629H296.927",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.742 264.629H310.97",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.781 264.629H325.019",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.688 148.07H277.972",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.688 167.023H255.506",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27 167.023H346.079",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.438 190.906H402.247",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.723 167.023H394.532",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.123 186.686H351.699V195.109H360.123V186.686Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.164 190.906H343.973",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.845 186.686H293.422V195.109H301.845V186.686Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.891 190.906H285.7",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.56 186.686H235.137V195.109H243.56V186.686Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.215 280.07H417.695",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.023 280.07H391.192",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.922 280.07H298.296",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 280.07H240.807",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.383 285.516H417.699",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 285.516H363.959",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 285.516H265.321",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.695 290.963H417.696",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 290.963H377.582",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.402 290.963H293.759",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 290.963H248.675",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.574 296.408H417.699",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.004 296.408H397.549",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 296.408H226.583",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.508 301.855H417.698",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.445 301.855H401.786",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 301.855H360.333",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.781 301.855H295.577",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 301.855H234.451",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.918 307.303H417.695",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.668 307.303H390.588",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 307.303H313.734",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 307.303H265.321",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.117 312.758H417.698",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.922 312.758H354.886",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.188 312.758H239.601",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.293 329.223H243.573",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.273 329.223H368.553",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.891 329.223H334.852",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57 329.223H416.998",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.441 158.715C221.441 158.715 225.347 159.615 226.247 155.106C227.146 150.598 223.538 153 223.538 155.403C223.538 157.806 224.744 160.208 229.243 156.609C233.751 153 232.545 153.603 235.254 156.312C237.963 159.021 235.551 159.615 240.959 157.518C246.367 155.412 246.664 156.312 246.367 158.121C246.07 159.921 244.864 159.021 249.976 157.222C255.087 155.422 257.49 153.919 256.887 156.322C256.284 158.724 254.178 159.327 258.093 156.619C262.008 153.91 264.401 145.199 261.098 151.813C257.796 158.428 256.59 157.518 261.395 156.619C266.2 155.719 267.703 152.416 267.703 154.819C267.703 157.222 263.798 158.724 267.703 157.222C271.609 155.719 273.111 154.216 273.111 155.719C273.111 157.222 269.503 159.921 274.614 157.518C279.726 155.116 281.228 152.407 281.228 154.513C281.228 156.619 280.329 156.016 281.228 156.619C282.128 157.222 280.329 155.412 283.028 156.322C285.737 157.222 284.531 159.031 288.436 157.528C292.342 156.025 292.045 153.919 294.141 156.025C296.247 158.131 294.141 161.137 299.846 158.428C305.551 155.719 307.054 157.222 308.863 157.528C310.663 157.825 312.165 157.825 313.371 157.825C314.578 157.825 314.271 156.619 317.277 157.825C320.282 159.031 321.182 159.031 322.982 159.031H326.59",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.949 159.012C344.949 159.012 346.452 158.409 349.151 156.906C351.851 155.403 358.771 150.292 359.068 153.604C359.365 156.906 351.554 161.118 352.454 157.509C353.353 153.9 358.762 155.71 362.667 157.212C366.573 158.715 367.472 156.916 372.287 156.916C377.102 156.916 376.489 158.418 378.901 159.022C381.304 159.625 380.404 159.022 384.606 157.222C388.808 155.422 385.812 146.702 383.103 152.714C380.395 158.725 379.495 161.127 385.812 158.122C392.12 155.116 390.321 158.725 391.221 158.725C392.12 158.725 390.618 159.022 394.226 157.519C397.835 156.016 393.326 158.122 396.026 158.725C398.735 159.328 400.228 156.322 402.64 155.422C405.043 154.523 405.349 157.222 405.349 157.222H407.752",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.641 101.015C219.641 101.015 221.143 100.412 223.546 96.8127C225.949 93.2136 222.043 92.0075 221.143 95.9129C220.244 99.8183 218.138 104.327 224.752 101.024C231.366 97.7221 228.954 91.4045 226.858 96.2192C224.752 101.024 225.355 105.839 231.663 102.23C237.971 98.6218 238.574 96.5255 239.474 98.3251C240.374 100.125 237.071 100.728 242.48 101.034C247.888 101.331 248.788 99.5312 251.19 98.6314C253.593 97.7316 254.799 98.6314 254.799 98.6314C254.799 98.6314 255.699 98.9281 256.905 98.9281C258.111 98.9281 259.614 98.0284 260.207 98.9281C260.81 99.8279 254.196 101.034 262.007 99.8279C269.817 98.6218 271.626 93.5199 272.22 97.4253C272.823 101.331 266.812 104.633 266.812 101.034C266.812 97.4349 270.42 93.8262 276.125 97.1286C281.83 100.431 281.534 101.331 284.539 101.934C287.545 102.537 292.35 99.2249 292.35 99.2249C292.35 99.2249 292.053 99.5216 293.853 100.431C295.652 101.331 295.059 101.331 298.361 100.431C301.664 99.5312 298.964 100.134 303.473 99.5312C307.981 98.9281 310.087 99.2344 308.278 100.737C306.469 102.24 301.367 100.134 307.981 98.9377C314.595 97.7316 315.495 99.8375 315.495 100.737C315.495 101.637 317.295 101.943 318.798 101.34C320.3 100.737 323.306 100.441 323.306 100.441",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.453 83.2878C227.453 83.2878 231.234 82.6943 234.565 81.5169C236.556 80.8182 238.384 79.8992 239.169 78.7793C241.275 75.7737 234.967 76.6735 231.052 80.5789C227.137 84.4843 233.455 84.781 241.572 82.0817C249.689 79.3823 249.383 72.4618 243.975 77.5732C238.566 82.6847 240.672 83.8812 249.086 82.0817C257.5 80.2821 268.02 78.1763 264.708 81.1819C261.405 84.1875 260.505 82.6847 266.21 81.4786C271.915 80.2726 275.524 77.5732 274.624 79.6791C273.724 81.7849 271.322 84.4843 275.83 82.388C280.339 80.2821 279.736 82.388 279.736 82.388C287.853 81.4882 292.352 71.2652 286.647 74.8739C280.942 78.4826 280.942 83.2877 286.044 82.991C291.155 82.6943 295.96 77.8795 293.558 80.2821C291.155 82.6847 287.25 84.4843 295.664 82.388C304.077 80.2821 306.786 75.7737 306.183 78.7793C305.58 81.7849 305.284 81.4882 308.289 81.4882C311.295 81.4882 316.703 77.2861 314.903 80.2821C313.104 83.2878 312.195 83.5845 314.903 82.991C317.612 82.388 321.518 80.2821 322.714 80.2821C323.911 80.2821 320.312 83.5845 323.92 83.2878C327.529 82.991 335.043 78.4826 335.043 78.4826",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.621 78.4824C326.621 78.4824 334.135 83.5939 335.935 83.5939",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.461 188.838L296.351 193.012L305.588 181.994",
    stroke: "#DFFF02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.634 227.537C274.452 227.537 274.261 227.499 274.089 227.422L263.875 223.182C263.138 222.876 262.794 222.033 263.1 221.306C263.406 220.578 264.249 220.224 264.976 220.53L275.19 224.771C275.927 225.077 276.271 225.919 275.965 226.647C275.735 227.202 275.199 227.528 274.634 227.528V227.537Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.749 220.109L15.738 118.234C12.1197 116.606 10.502 112.366 12.1293 108.748C13.7565 105.129 17.997 103.512 21.6152 105.139L248.626 207.015L242.749 220.119V220.109Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.549 116.32L21.6137 105.13C17.9955 103.503 13.7455 105.13 12.1278 108.738C10.5006 112.357 12.1278 116.607 15.7365 118.224L40.0495 129.223L46.549 116.32Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.627 207.006L271.351 222.57L269.935 225.595L242.75 220.11L248.627 207.006Z",
    fill: "white",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.509 113.611L21.6137 105.13C17.9955 103.503 13.7455 105.13 12.1278 108.738C10.5006 112.357 12.1278 116.607 15.7365 118.224L33.8468 126.351L40.5186 113.601L40.509 113.611Z",
    fill: "#DFFF02",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_35949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 451.887,
    height: 410,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractOfAdhesion);
export default __webpack_public_path__ + "static/media/contractOfAdhesion.a36a779f21c43752c1e55bca50297184.svg";
export { ForwardRef as ReactComponent };